import {
  limitedReleaseBySNConstants,
  createLimitedReleaseBySNConstants,
  editLimitedReleaseBySNConstants,
  addTargetLimitedReleaseBySNConstants,
  removeTargetLimitedReleaseBySNConstants,
  activateLimitedReleaseBySNConstants,
  deactivateLimitedReleaseBySNConstants,
  deleteLimitedReleaseBySNConstants,
} from "../_redux-constants";
import { limitedReleasesSNService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getLimitedReleaseBySN(queryParams) {
  function getLimitedReleaseBySNLoad() {
    return { type: limitedReleaseBySNConstants.LIMITED_RELEASE_BY_SN_LOADING };
  }
  function getLimitedReleaseBySNSuccess(data) {
    return {
      type: limitedReleaseBySNConstants.LIMITED_RELEASE_BY_SN_SUCCESS,
      data,
    };
  }
  function getLimitedReleaseBySNFailure(error) {
    return {
      type: limitedReleaseBySNConstants.LIMITED_RELEASE_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getLimitedReleaseBySNLoad());
    return limitedReleasesSNService.getLimitedReleaseBySN(queryParams).then(
      (data) => {
        dispatch(getLimitedReleaseBySNSuccess(data));
      },
      (error) => {
        dispatch(getLimitedReleaseBySNFailure(error?.toString()));
      }
    );
  };
}

function createLimitedReleaseBySN(requestBody, queryParams) {
  function createLimitedReleaseBySNLoad() {
    return {
      type: createLimitedReleaseBySNConstants.CREATE_LIMITED_RELEASE_BY_SN_LOADING,
    };
  }
  function createLimitedReleaseBySNSuccess(data) {
    return {
      type: createLimitedReleaseBySNConstants.CREATE_LIMITED_RELEASE_BY_SN_SUCCESS,
      data,
    };
  }
  function createLimitedReleaseBySNFailure(error) {
    return {
      type: createLimitedReleaseBySNConstants.CREATE_LIMITED_RELEASE_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createLimitedReleaseBySNLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesSNService
        .createLimitedReleaseBySN(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createLimitedReleaseBySNSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(createLimitedReleaseBySNFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editLimitedReleaseBySN(requestBody, queryParams) {
  function editLimitedReleaseBySNLoad() {
    return {
      type: editLimitedReleaseBySNConstants.EDIT_LIMITED_RELEASE_BY_SN_LOADING,
    };
  }
  function editLimitedReleaseBySNSuccess(data) {
    return {
      type: editLimitedReleaseBySNConstants.EDIT_LIMITED_RELEASE_BY_SN_SUCCESS,
      data,
    };
  }
  function editLimitedReleaseBySNFailure(error) {
    return {
      type: editLimitedReleaseBySNConstants.EDIT_LIMITED_RELEASE_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editLimitedReleaseBySNLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesSNService
        .editLimitedReleaseBySN(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editLimitedReleaseBySNSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editLimitedReleaseBySNFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function addTargetLimitedReleaseBySN(requestBody, queryParams) {
  function addTargetLimitedReleaseBySNLoad() {
    return {
      type: addTargetLimitedReleaseBySNConstants.ADD_TARGET_LIMITED_RELEASE_BY_SN_LOADING,
    };
  }
  function addTargetLimitedReleaseBySNSuccess(data) {
    return {
      type: addTargetLimitedReleaseBySNConstants.ADD_TARGET_LIMITED_RELEASE_BY_SN_SUCCESS,
      data,
    };
  }
  function addTargetLimitedReleaseBySNFailure(error) {
    return {
      type: addTargetLimitedReleaseBySNConstants.ADD_TARGET_LIMITED_RELEASE_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addTargetLimitedReleaseBySNLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesSNService
        .addTargetLimitedReleaseBySN(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(addTargetLimitedReleaseBySNSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(addTargetLimitedReleaseBySNFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function removeTargetLimitedReleaseBySN(queryParams) {
  function removeTargetLimitedReleaseBySNLoad() {
    return {
      type: removeTargetLimitedReleaseBySNConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_SN_LOADING,
    };
  }
  function removeTargetLimitedReleaseBySNSuccess(data) {
    return {
      type: removeTargetLimitedReleaseBySNConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_SN_SUCCESS,
      data,
    };
  }
  function removeTargetLimitedReleaseBySNFailure(error) {
    return {
      type: removeTargetLimitedReleaseBySNConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(removeTargetLimitedReleaseBySNLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesSNService.removeTargetLimitedReleaseBySN(queryParams).then(
        (data) => {
          dispatch(removeTargetLimitedReleaseBySNSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(removeTargetLimitedReleaseBySNFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function activateLimitedReleaseBySN(queryParams) {
  function activateLimitedReleaseBySNLoad() {
    return {
      type: activateLimitedReleaseBySNConstants.ACTIVATE_LIMITED_RELEASE_BY_SN_LOADING,
    };
  }
  function activateLimitedReleaseBySNSuccess(data) {
    return {
      type: activateLimitedReleaseBySNConstants.ACTIVATE_LIMITED_RELEASE_BY_SN_SUCCESS,
      data,
    };
  }
  function activateLimitedReleaseBySNFailure(error) {
    return {
      type: activateLimitedReleaseBySNConstants.ACTIVATE_LIMITED_RELEASE_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateLimitedReleaseBySNLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesSNService.activateLimitedReleaseBySN(queryParams).then(
        (data) => {
          dispatch(activateLimitedReleaseBySNSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(activateLimitedReleaseBySNFailure(error?.toString()));
          reject(error);
        }
      );
    });
  };
}

function deactivateLimitedReleaseBySN(queryParams) {
  function deactivateLimitedReleaseBySNLoad() {
    return {
      type: deactivateLimitedReleaseBySNConstants.DEACTIVATE_LIMITED_RELEASE_BY_SN_LOADING,
    };
  }
  function deactivateLimitedReleaseBySNSuccess(data) {
    return {
      type: deactivateLimitedReleaseBySNConstants.DEACTIVATE_LIMITED_RELEASE_BY_SN_SUCCESS,
      data,
    };
  }
  function deactivateLimitedReleaseBySNFailure(error) {
    return {
      type: deactivateLimitedReleaseBySNConstants.DEACTIVATE_LIMITED_RELEASE_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateLimitedReleaseBySNLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesSNService.deactivateLimitedReleaseBySN(queryParams).then(
        (data) => {
          dispatch(deactivateLimitedReleaseBySNSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(deactivateLimitedReleaseBySNFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function deleteLimitedReleaseBySN(queryParams) {
  function deleteLimitedReleaseBySNLoad() {
    return {
      type: deleteLimitedReleaseBySNConstants.DELETE_LIMITED_RELEASE_BY_SN_LOADING,
    };
  }
  function deleteLimitedReleaseBySNSuccess(data) {
    return {
      type: deleteLimitedReleaseBySNConstants.DELETE_LIMITED_RELEASE_BY_SN_SUCCESS,
      data,
    };
  }
  function deleteLimitedReleaseBySNFailure(error) {
    return {
      type: deleteLimitedReleaseBySNConstants.DELETE_LIMITED_RELEASE_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteLimitedReleaseBySNLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesSNService.deleteLimitedReleaseBySN(queryParams).then(
        (data) => {
          dispatch(deleteLimitedReleaseBySNSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(deleteLimitedReleaseBySNFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

export const limitedReleasesSNActions = {
  getLimitedReleaseBySN,
  createLimitedReleaseBySN,
  editLimitedReleaseBySN,
  addTargetLimitedReleaseBySN,
  removeTargetLimitedReleaseBySN,
  activateLimitedReleaseBySN,
  deactivateLimitedReleaseBySN,
  deleteLimitedReleaseBySN,
};
